export const USER_STATUS = Object.freeze({
  AWAITING_APPROVAL: "Awaiting approval",
  ACTIVE: "Active",
  NOT_ACTIVE: "Not Active",
  SUSPENDED: "Suspended",
  DISABLED: "Disabled",
  PASSWORD_RESET_NEEDED: "Password Reset Needed",
});

export const USER_STATUS_OPTIONS = Object.freeze([
  USER_STATUS.AWAITING_APPROVAL,
  USER_STATUS.ACTIVE,
  USER_STATUS.NOT_ACTIVE,
  USER_STATUS.SUSPENDED,
  USER_STATUS.DISABLED,
  USER_STATUS.PASSWORD_RESET_NEEDED,
]);

const USER_STATUS_BY_NORMALIZED_VALUE = Object.freeze({
  "awaiting approval": USER_STATUS.AWAITING_APPROVAL,
  active: USER_STATUS.ACTIVE,
  "not active": USER_STATUS.NOT_ACTIVE,
  suspended: USER_STATUS.SUSPENDED,
  disabled: USER_STATUS.DISABLED,
  "password reset needed": USER_STATUS.PASSWORD_RESET_NEEDED,
});

export function normalizeUserStatus(value) {
  const normalizedValue = String(value || "").trim().toLowerCase();
  return USER_STATUS_BY_NORMALIZED_VALUE[normalizedValue] || "";
}

export function isUserStatus(value, status) {
  return normalizeUserStatus(value) === status;
}

export function isActiveUserStatus(value) {
  return isUserStatus(value, USER_STATUS.ACTIVE);
}

export function shouldTriggerApproval(currentStatus, nextStatus) {
  return (
    isUserStatus(currentStatus, USER_STATUS.AWAITING_APPROVAL) &&
    isUserStatus(nextStatus, USER_STATUS.ACTIVE)
  );
}

export function getUserStatusLabel(value) {
  return normalizeUserStatus(value) || String(value || "");
}

export function getUserStatusBadgeColor(value) {
  return isActiveUserStatus(value) ? "green" : "neutral";
}
